import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {
  Title,
  SubTitle,
  LeftSide,
  Column,
  InputContainer,
  UploadContainer,
  Text2,
  UnderlineText2,
  ImagesContainer,
  Row2,
  Column2,
  ThinText,
  AddPhotoContainer,
  AddInputContainer,
  IconsContainer,
  IconContainer,
  StyledInput,
  UploadInputBig,
  UploadInputSmall,
} from '../SignupPage.styles';
import Button from '../../../../components/utils/Button/Button';
import { ReactComponent as Logo } from '../../../../assets/icons/logoBlack.svg';
import { ReactComponent as Youtube } from '../../../../assets/icons/yt.svg';
import { ReactComponent as AddPhoto } from '../../../../assets/icons/addPhotoBlack.svg';
import { ReactComponent as Minus } from '../../../../assets/icons/minus.svg';
import { ReactComponent as Add } from '../../../../assets/icons/add.svg';
import { ReactComponent as Delete } from '../../../../assets/icons/remove.svg';
import { useDispatch, useSelector } from 'react-redux';
import { createVendorPending } from '../../../../store/slice/vendor/slice';
import { selectOnboardingInfo, setOnboardingInfo, setVendorImages } from '../../../../store/slice/onboarding/slice';
import { ReactComponent as LeftChevron } from '../../../../assets/icons/chevronLeft.svg';
import { useNavigate } from 'react-router-dom';
import { notifyError } from '../../../../utils/notify';

const Step3Page = ({ handleSignUp }) => {
  const dispatch = useDispatch();
  const onboardingInfo = useSelector(selectOnboardingInfo);
  const navigation = useNavigate();

  const [ytLinks, setYtLinks] = useState(onboardingInfo.links);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedImagesPrev, setSelectedImagesPrev] = useState(onboardingInfo.images);
  const pending = useSelector(createVendorPending);

  const handleAddYtLink = () => {
    if (ytLinks.length < 3) {
      setYtLinks([...ytLinks, '']);
      dispatch(setOnboardingInfo({ links: ytLinks }));
    }
  };

  const handleRemoveYtLink = indexToRemove => {
    let filteredArray = ytLinks.filter((_, index) => index !== indexToRemove);
    setYtLinks(filteredArray);
    dispatch(setOnboardingInfo({ links: filteredArray }));
  };

  // Function to handle file input change
  const handleFileInputChange = e => {
    const selectedFiles = e.target.files;
    const selectedImagesArray = [];
    const imagesArray = [];
    let isAnyBigger = false;

    for (let i = 0; i < selectedFiles.length; i++) {
      const imageFile = selectedFiles[i];
      if (imageFile.size > 3e6) {
        // console.log('bigger');
        isAnyBigger = true;
      } else {
        // console.log('smaller');
        selectedImagesArray.push(URL.createObjectURL(imageFile));
        imagesArray.push(imageFile);
      }
    }
    if (isAnyBigger) {
      notifyError('Max size of image is 3MB');
    }

    // Calculate the total number of selected images
    const totalImages = selectedImagesPrev.length + selectedImagesArray.length;

    if (totalImages >= 5 && totalImages <= 20) {
      setSelectedImagesPrev(prevSelectedImages => [...prevSelectedImages, ...selectedImagesArray]);
      setSelectedImages(prev => [...prev, ...imagesArray]);
      dispatch(setVendorImages(selectedImagesArray));
    } else {
      alert('Please select between 5 to 20 images.');
    }
  };

  const handleRemoveImage = indexToRemove => {
    let filteredArray = selectedImagesPrev.filter((_, index) => index !== indexToRemove);
    setSelectedImagesPrev(filteredArray);
    dispatch(setOnboardingInfo({ images: filteredArray }));
  };

  // Validation functions
  const isValid = selectedImagesPrev.length >= 5 && selectedImagesPrev.length <= 20;

  const onContinue = () => {
    handleSignUp();
  };

  return (
    <LeftSide className="height">
      <LeftChevron
        width={20}
        height={20}
        onClick={() => {
          navigation(-1);
        }}
        className="icon-back"
      />
      <Logo width={110} height={58} />

      <Column>
        <SubTitle>Step 2</SubTitle>
        <Title>Previous Work</Title>
      </Column>
      <UploadContainer onClick={() => {}} $selected={!!selectedImages.length}>
        {selectedImagesPrev.length === 0 ? (
          <>
            <UploadInputBig multiple onChange={handleFileInputChange} type="file" accept=".jpg, .jpeg, .png" />

            <Column2>
              <AddPhoto />
              <Text2>Upload Photos</Text2>
              <Row2>
                <UnderlineText2>Click here</UnderlineText2>
                <Text2>or Drag</Text2>
              </Row2>
            </Column2>
            <ThinText>Min 5 photos, Max 20 photos.</ThinText>
          </>
        ) : (
          <ImagesContainer>
            {selectedImagesPrev.map((image, index) => (
              <IconContainer key={index}>
                <img
                  style={{
                    width: 80,
                    borderRadius: 10,
                    height: 80,
                  }}
                  key={index}
                  src={image}
                  alt={`Selected ${index + 1}`}
                />
                <Minus
                  onClick={() => handleRemoveImage(index)}
                  style={{
                    position: 'absolute',
                    right: -1,
                    top: 2,
                    cursor: 'pointer',
                  }}
                />
              </IconContainer>
            ))}
            {selectedImagesPrev.length !== 20 && (
              <AddPhotoContainer>
                <AddPhoto />
                <UploadInputSmall multiple onChange={handleFileInputChange} type="file" accept=".jpg, .jpeg, .png" />
              </AddPhotoContainer>
            )}
          </ImagesContainer>
        )}
      </UploadContainer>
      <InputContainer>
        {ytLinks.map((ytLink, index) => (
          <AddInputContainer key={index}>
            <StyledInput
              icon={true}
              leftIcon={<Youtube opacity={ytLink !== '' ? 1 : 0.5} className="icon" />}
              placeholder={'youtube.com/yourvideo'}
              value={ytLink}
              onChange={e => {
                const updatedYtLinks = [...ytLinks];
                updatedYtLinks[index] = e.target.value;
                setYtLinks(updatedYtLinks);
              }}
            />
            <IconsContainer $width>
              {index > 0 && (
                <Delete className="icon-delete" onClick={() => handleRemoveYtLink(index)} width={24} height={24} />
              )}
              {index === ytLinks.length - 1 && index < 2 && (
                <Add className="icon-add" onClick={ytLink !== '' ? handleAddYtLink : null} width={24} height={24} />
              )}
            </IconsContainer>
          </AddInputContainer>
        ))}
      </InputContainer>

      <Button disabled={!isValid || pending} title={'Continue'} onClick={onContinue} width loading={pending} />
    </LeftSide>
  );
};

export default Step3Page;
